import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';

type ProblemsBlankSlateProps = {
  totalRows: number;
  onShowAll: () => void;
};

// The Problems filter is never disabled — a clean file shows this instead,
// so "no errors" reads distinctly from "the filter is broken".
export const ProblemsBlankSlate = ({ totalRows, onShowAll }: ProblemsBlankSlateProps) => (
  <div className="flex flex-1 flex-col items-center justify-center gap-2 px-6 py-10 text-center">
    <CheckCircle2 className="h-8 w-8 text-emerald-500" aria-hidden />
    <p className="text-sm font-medium text-gray-900">No import problems to show…</p>
    <p className="text-sm text-gray-600">Every one of the {totalRows} rows in this file matched.</p>
    <Button variant="outline" size="sm" className="mt-2" onClick={onShowAll}>
      Show all {totalRows} rows
    </Button>
  </div>
);
